import { FETCH_ALL_ORGS } from './types';

const initialState = {
  loading: false,
  data: {},
};

export default class OrgsReducers {
  static allOrgsReducer(state = initialState, action) {
    switch (action.type) {
      case `${FETCH_ALL_ORGS}_PENDING`:
        return { ...state, loading: true };
      case `${FETCH_ALL_ORGS}_FULFILLED`:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      case `${FETCH_ALL_ORGS}_REJECTED`:
        return {
          ...state,
          loading: false,
          data: action.payload,
        };
      default:
        return state;
    }
  }
}
